export default __webpack_public_path__ + "static/media/png_file.09f9947c.png";